import {
  Box,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { memo, useEffect, useState } from "react";

import { MoneyFormat, MoneyFormatv2 } from "../../library/MoneyFormat";
import { useThemes } from "../Theme/theme";
import { useSelector } from "react-redux";

function GSTR3BTable11({ data }) {

  const [tableData, setTableData] = useState([])

  const companyDetails = useSelector((state) => state?.companyReducer?.companyDetails)

  useEffect(() => {
    if (data) {
      GSTR3BTable1FN()
    }
  }, [data])


  async function GSTR3BTable1FN() {
    const taxData = {
      TaxabilityCD1: {
        totalTaxableValue: 0,
        integratedTax: 0,
        centralTax: 0,
        stateTax: 0,
        cess: 0,
      },
      TaxabilityCD2: {
        totalTaxableValue: 0,
        integratedTax: 0,
        centralTax: 0,
        stateTax: 0,
        cess: 0,
      },
      TaxabilityCD3: {
        totalTaxableValue: 0,
        integratedTax: 0,
        centralTax: 0,
        stateTax: 0,
        cess: 0,
      },
      TaxabilityCD4: {
        totalTaxableValue: 0,
        integratedTax: 0,
        centralTax: 0,
        stateTax: 0,
        cess: 0,
      },
      TaxabilityCD5: {
        totalTaxableValue: 0,
        integratedTax: 0,
        centralTax: 0,
        stateTax: 0,
        cess: 0,
      },
    };

    if (data.length > 0) {
      const GSTR3BSales = data[0]?.GSTR1Data;
      const GSTR3BPurchase = data[0]?.GSTR2Data;

      GSTR3BSales.forEach((invoice) => {
        invoice.relatedinvoicelineitems?.forEach((item) => {
          const taxableValue = item.itemrate * item.quantity;
          const gstItem = item.relatedinvoicelinegst[0];


          switch (item.relateditemmaster[0].taxabilitycd) {
            case "1":
              const taxAmount = (taxableValue * gstItem?.gstrate) / 100;

              if (
                companyDetails?.relatedaddressentity[0]?.countrycode ===
                "IndiaState" &&
                invoice?.relatedpartymaster[0]?.gstcategory !== "SEZ" &&
                gstItem.gstrate !== 0
              ) {
                taxData.TaxabilityCD1.totalTaxableValue += taxableValue;
                if (
                  companyDetails?.relatedaddressentity[0]?.statecode ===
                  invoice?.placeofsupply
                ) {
                  taxData.TaxabilityCD1.centralTax += taxAmount / 2;
                  taxData.TaxabilityCD1.stateTax += taxAmount / 2;
                } else {
                  taxData.TaxabilityCD1.integratedTax += taxAmount;
                }
                const cessAmount = gstItem?.cessamount || 0;
                taxData.TaxabilityCD1.cess += cessAmount;
              } else if (
                companyDetails?.relatedaddressentity[0]?.countrycode ===
                "IndiaState" &&
                invoice?.relatedpartymaster[0]?.gstcategory === "SEZ"
              ) {
                const cessAmount = gstItem?.cessamount || 0;
                taxData.TaxabilityCD2.totalTaxableValue += taxableValue;
                taxData.TaxabilityCD2.integratedTax += taxAmount;
                taxData.TaxabilityCD2.cess += cessAmount;
              }
              break;
            case "2":
              if (gstItem.GSTRate !== 0)
                taxData.TaxabilityCD3.totalTaxableValue += taxableValue;
              break;
            case "10":
              taxData.TaxabilityCD5.totalTaxableValue += taxableValue;
              break;
          }
        });
      });

      GSTR3BPurchase.forEach((purchase) => {
        if (purchase?.relatedpurchasetdsdetails[0].reversechargeflag === 1) {
          purchase.relatedpurchaselineitems.forEach((item) => {
            const taxableValue = item.itemrate * item.itemquantity;
            taxData.TaxabilityCD4.totalTaxableValue += taxableValue;
            const gstItem = item.relatedpurchaselinegst[0];
            const taxAmount = (taxableValue * gstItem?.gstrate) / 100;
            const cessAmount = gstItem?.cessamount || 0;
            taxData.TaxabilityCD4.cess += cessAmount;
            if (
              companyDetails?.relatedaddressentity[0]?.statecode ===
              purchase?.placeofsupply
            ) {
              taxData.TaxabilityCD4.centralTax += taxAmount / 2;
              taxData.TaxabilityCD4.stateTax += taxAmount / 2;
            } else {
              taxData.TaxabilityCD4.integratedTax += taxAmount;
            }
          });
        }
      });
    }

    setTableData([
      taxData.TaxabilityCD1,
      taxData.TaxabilityCD2,
      taxData.TaxabilityCD3,
      taxData.TaxabilityCD4,
      taxData.TaxabilityCD5,
    ]);
  }

  const { theme } = useThemes()

  const headCells = [
    {
      id: "1",
      label: "Nature of supplies",
      minWidht: 170,
    },
    {
      id: "2",
      label: "Total taxable value",
      minWidht: 120,
    },
    {
      id: "3",
      label: "Integrated tax",
      minWidht: 120,
    },
    {
      id: "4",
      label: "Central tax",
      minWidht: 120,
    },
    {
      id: "3",
      label: "State /ut tax",
      minWidht: 120,
    },
    {
      id: "3",
      label: "Cess",
      minWidht: 120,
    },
  ];

  const NatureOfSuppliesItems = [
    "(a) Outward Taxable  supplies  (other than zero rated, nil rated and exempted)",
    "(b) Outward Taxable  supplies  (zero rated )",
    "(c) Other Outward Taxable  supplies (Nil rated, exempted)",
    "(d) Inward supplies (liable to reverse charge)",
    "(e) Non-GST Outward supplies",
  ];

  return (
    <>
      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          marginTop: 3,
        }}
      >
        <Typography sx={{ paddingX: 1 }}>
          1. Details of Outward Supplies and inward supplies liable to reverse
          charge
        </Typography>
        <TableContainer
          sx={{
            maxHeight: 400,
            m: 1,
            "::-webkit-scrollbar": {
              width: 14,
            },
            "::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "::-webkit-scrollbar-thumb": {
              background: "#888",
            },
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              width: "100%",
              borderRadius: 2,
              maxHeight: 440,
              backgroundColor: "#f9f9fe",
            }}
          >
            <TableHead
              sx={{
                height: 12,
              }}
            >
              <TableRow>
                {headCells?.map((column) => (
                  <TableCell
                    align="center"
                    sx={{
                      color: "#FFF",
                      backgroundColor: theme.palette.secondary.main,
                      fontFamily: "overpass",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                    key={column.id}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {NatureOfSuppliesItems.map((text, index) => {
                return (
                  <TableRow>
                    <TableCell>{text}</TableCell>
                    <TableCell align="center">
                      {MoneyFormatv2(tableData[index]?.totalTaxableValue)}
                    </TableCell>
                    <TableCell align="center">
                      {MoneyFormatv2(tableData[index]?.integratedTax)}
                    </TableCell>
                    <TableCell align="center">
                      {MoneyFormatv2(tableData[index]?.centralTax)}
                    </TableCell>
                    <TableCell align="center">{MoneyFormatv2(tableData[index]?.stateTax)}</TableCell>
                    <TableCell align="center">{MoneyFormatv2(tableData[index]?.cess)}</TableCell>
                  </TableRow>
                );
              })}
              <TableRow>
                <TableCell>TOTAL</TableCell>
                <TableCell align="center">
                  {MoneyFormatv2(
                    tableData?.reduce(
                      (acc, value) => acc + value?.totalTaxableValue,
                      0
                    )
                  )}
                </TableCell>
                <TableCell align="center">
                  {MoneyFormatv2(
                    tableData?.reduce((acc, value) => acc + value?.integratedTax, 0)
                  )}
                </TableCell>
                <TableCell align="center">
                  {MoneyFormatv2(
                    tableData?.reduce((acc, value) => acc + value?.centralTax, 0)
                  )}
                </TableCell>
                <TableCell align="center">
                  {MoneyFormatv2(
                    tableData?.reduce((acc, value) => acc + value?.stateTax, 0)
                  )}
                </TableCell>
                <TableCell align="center">
                  {MoneyFormatv2(
                    tableData?.reduce((acc, value) => acc + value?.cess, 0)
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
}

export default memo(GSTR3BTable11);
